module.exports = __webpack_public_path__ + "media/promo/panasonic/images/article-14246aa068e612c10e48bdf1906652c5.jpg";